import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Campaign } from '../../models/campaign';
import { CampaignService } from '../../services/campaign.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-campaign',
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './campaign.component.html',
  styleUrl: './campaign.component.css'
})
export class CampaignComponent implements OnInit {
  public campaign!: Campaign;

  constructor(private route: ActivatedRoute, private campaignService: CampaignService) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('campaignId')!;
    this.campaignService.getCampaign(id).subscribe({
      next: (result) => {
        this.campaign = result;
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  setEditCompensationId(editCompensationId: string) {
    // var compensation = this.campaign.compensations!.find(c => c.id=editCompensationId);

    // if (compensation === undefined) {
    //   throw "missing compensatioin";
    // }

    // this.editCompensationModel = compensation;
  }

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];  // Format as 'YYYY-MM-DD'
  }

}
